import { FormText as _FormText, FormTextProps as _FormTextProps } from "reactstrap";

    export const FormText = _FormText;
    export type FormTextProps = _FormTextProps;
    